import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useCartWorkflowWizardStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        columnGap: tokens.spacingHorizontalXXL,
        ':has(.wrapped)': {
            flexDirection: 'column'
        },
        '@media screen and (max-width: 1100px)': {
            flexDirection: 'column',
            ...shorthands.padding(0)
        }
    },
    breadCrumb: {
        '@media screen and (max-width: 480px)': {
            display: 'none'
        }
    },
    wizardContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalS
    },
    progressBar: {},
    stepComponentWrapper: {
        width: '900px',
        maxWidth: '900px',
        '@media screen and (max-width: 1100px)': {
            width: '100%',
            maxWidth: '100%'
        }
    },
    sticky: {
        position: 'sticky',
        top: tokens.spacingVerticalL
    },
    proceedButton: {
        marginTop: tokens.spacingVerticalL,
        marginBottom: tokens.spacingVerticalL
    },
    summaryWrapper: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalL,
        width: '450px',
        maxWidth: '450px',
        minWidth: '300px',
        top: tokens.spacingVerticalXXXL,
        '@media screen and (max-width: 1100px)': {
            width: '100%',
            maxWidth: '100%'
        },
        '@media screen and (max-width: 480px)': {
            flexDirection: 'column'
        }
    },
    summaryCards: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalL
    },
    securedCheckoutHeader: {
        fontSize: tokens.fontSizeHero900,
        lineHeight: tokens.fontSizeHero900,
        fontWeight: 'bold',
        ...shorthands.margin('0', '0', '20px'),
        '@media screen and (max-width: 480px)': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        }
    },
    statusInfoBox: {
        width: '100%'
    },
    loadingWheel: {
        marginTop: tokens.spacingVerticalM
    }
});

export default useCartWorkflowWizardStyles;
